var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"story-btn",attrs:{"color":"#FD5D91","x-large":""},on:{"click":function($event){return _vm.onBtnClick()}}},[_vm._t("default"),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }